function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.75 6.00028C10.7504 7.0312 10.3967 8.03098 9.74825 8.83241C9.09979 9.63384 8.1958 10.1883 7.1875 10.4031C6.17921 10.6179 5.12773 10.4799 4.20895 10.0123C3.29017 9.54474 2.5598 8.77585 2.14 7.83428L0.749 8.39928C1.30042 9.66274 2.27003 10.6978 3.49482 11.3305C4.7196 11.9632 6.12488 12.1549 7.47438 11.8734C8.82388 11.5919 10.0353 10.8544 10.905 9.78481C11.7747 8.71523 12.2497 7.37883 12.25 6.00028C12.2501 4.74801 11.8583 3.52711 11.1296 2.50868C10.4009 1.49025 9.37187 0.725332 8.18662 0.321137C7.00138 -0.0830583 5.71937 -0.106276 4.52027 0.254737C3.32117 0.615751 2.26508 1.3429 1.5 2.33428V0.50028H0V4.50028L0.75 5.25028H4.25V3.75028H2.352C2.84711 2.89195 3.61167 2.22104 4.52705 1.84165C5.44243 1.46226 6.45744 1.39561 7.41457 1.65205C8.3717 1.90848 9.21743 2.47366 9.82052 3.25988C10.4236 4.0461 10.7503 5.00939 10.75 6.00028V6.00028Z",
  fill: "white"
});

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.58eff846.svg";
export { ForwardRef as ReactComponent };